import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/images/header_logo.png'


const _hoisted_1 = { class: "bg-mentalnc text-gray-700" }
const _hoisted_2 = { class: "p-2 h-14 grid grid-cols-12 content-center" }
const _hoisted_3 = { class: "col-span-5 flex items-center justify-start" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "col-span-2 flex items-center justify-center" }
const _hoisted_7 = { class: "col-span-5 flex items-center justify-end" }
const _hoisted_8 = { class: "mr-4" }
const _hoisted_9 = { class: "mr-4" }
const _hoisted_10 = { class: "mr-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon_text = _resolveComponent("base-icon-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layouts_auth_width, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (!_ctx.store.state.menu.sidebar.open)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_base_icon_text, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('menu/switchSidebarOpen'))),
                        class: "cursor-pointer",
                        path: _ctx.mdiMenu,
                        text: "メニュー"
                      }, null, 8, ["path"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_base_icon_text, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.dispatch('menu/switchSidebarOpen'))),
                        class: "cursor-pointer",
                        path: _ctx.mdiClose,
                        text: _ctx.t('word.close')
                      }, null, 8, ["path", "text"])
                    ]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: _ctx.homePath }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  class: "transition-bounce w-12",
                  src: _imports_0,
                  alt: "LOGO"
                }, null, -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, { to: "/account" }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon_text, {
                    class: "transition-bounce",
                    path: _ctx.mdiAccount,
                    text: "マイページ"
                  }, null, 8, ["path"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, { to: "/course" }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon_text, {
                    class: "transition-bounce",
                    path: _ctx.mdiBookOpenPageVariant,
                    text: _ctx.t('course.title')
                  }, null, 8, ["path", "text"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, { to: "/seminar" }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon_text, {
                    class: "transition-bounce",
                    path: _ctx.mdiCalendarCheck,
                    text: "セミナー"
                  }, null, 8, ["path"])
                ]),
                _: 1
              })
            ]),
            (_ctx.props.is_well_labo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("a", { href: _ctx.wellLaboUrl }, [
                    _createVNode(_component_base_icon_text, {
                      class: "transition-bounce",
                      path: _ctx.mdiPlayCircle,
                      text: _ctx.t('word.well_labo'),
                      iconClass: "text-wellLabo",
                      open: true
                    }, null, 8, ["path", "text"])
                  ], 8, _hoisted_12)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}